import { createSignal, splitProps } from 'solid-js';
import InputField from '#src/client/common/interactive/InputField.jsx';
import Label from '#src/client/common/elements/Label.jsx';
import style from '#src/client/common/interactive/LabeledInputField.module.css';
import isEmpty from '#src/client/common/utils/isEmpty.js';
import colors from '#src/client/common/colors.js';
import Items from '#src/client/common/layout/Items.jsx';

function LabeledInputField(props) {
    const [isTooltipOpen, setIsTooltipOpen] = createSignal(false);

    const [local, others] = splitProps(props, [
        'error',
        'showErrorLeft',
        'inputType',
        'label',
        'explanation',
        'showTooltipExplanation',
        'color',
    ]);

    const getColor = () => {
        if (local.error) {
            return colors.negative;
        }

        const color = !isEmpty(local.color) ? local.color : colors.primary;
        return colors[color] ? style[color] : color;
    };

    const onToggleTooltip = () => {
        setIsTooltipOpen(!isTooltipOpen());
    };

    return (
        <Items size="small">
            <Show when={local.label}>
                <Items type="wrap" size="medium" extra={['alignCenter']}>
                    <Label>{local.label}</Label>
                    <Show when={local.showTooltipExplanation && local.explanation}>
                        <button onClick={onToggleTooltip} class={`${style.tooltip} ${isTooltipOpen() ? style.open : ''}`}>?</button>
                    </Show>
                </Items>
            </Show>
            <Show when={isTooltipOpen()}>
                <div class={style.explanationBox}>
                    <div class={style.explanation}>{local.explanation}</div>
                </div>
            </Show>
            <div>
                <div class={`${style.errorBox} ${others.autoWidth ? style.autoWidthBox : ''}`}>
                    <InputField
                        {...others}
                        color={getColor()}
                        inputType={local.inputType} />
                    <Show when={local.error}>
                        <div class={`${style.errorPopover} ${local.showErrorLeft ? style.errorPopoverLeft : ''}`}>{local.error}</div>
                    </Show>
                </div>
            </div>
            <Show when={!local.showTooltipExplanation && local.explanation}>
                <div class={style.explanation}>{local.explanation}</div>
            </Show>
        </Items>
    );
}

export default LabeledInputField;
